import React, { Component } from "react";
import { Grid, Card, Icon } from "@material-ui/core";
import { connect } from "react-redux";
import { compose } from "redux";
import * as actions from "../../../store/actions/index";

const overviewItems = [
  { key: "totalLeads",         label: "Leads",          icon: "person_add",       color: "#1565C0", bg: "rgba(21, 101, 192, 0.08)"  },
  { key: "totalContacts",      label: "Contacts",       icon: "contacts",         color: "#00695C", bg: "rgba(0, 105, 92, 0.08)"    },
  { key: "totalCompanies",     label: "Companies",      icon: "business",         color: "#4527A0", bg: "rgba(69, 39, 160, 0.08)"   },
  { key: "totalOpportunities", label: "Opportunities",  icon: "attach_money",     color: "#E65100", bg: "rgba(230, 81, 0, 0.08)"    },
  { key: "totalProjects",      label: "Projects",       icon: "business_center",  color: "#00838F", bg: "rgba(0, 131, 143, 0.08)"   },
  { key: "totalTasks",         label: "Tasks",          icon: "check_circle",     color: "#558B2F", bg: "rgba(85, 139, 47, 0.08)"   },
];

class CrmOverview extends Component {
  render() {
    const { crmOverview = {} } = this.props;

    const cardStyle = {
      background: "linear-gradient(135deg, rgba(255,255,255,0.97), rgba(240,248,255,0.85))",
      borderRadius: "20px",
      border: "1px solid rgba(255,255,255,0.6)",
      boxShadow: "0 10px 40px -10px rgba(31,38,135,0.1)",
      overflow: "hidden",
      marginBottom: "28px",
    };

    const headerStyle = {
      padding: "20px 28px 16px",
      background: "linear-gradient(90deg, rgba(3,169,244,0.07), rgba(0,150,136,0.04))",
      borderBottom: "1px solid rgba(0,0,0,0.04)",
    };

    const titleStyle = {
      margin: 0,
      fontSize: "1.2rem",
      fontWeight: 700,
      color: "#0288D1",
      fontFamily: "'Inter', sans-serif",
      letterSpacing: "-0.01em",
    };

    return (
      <Card elevation={0} style={cardStyle}>
        <div style={headerStyle}>
          <h3 style={titleStyle}>CRM Overview</h3>
        </div>
        <div style={{ padding: "20px 24px" }}>
          <Grid container spacing={2}>
            {overviewItems.map((item) => (
              <Grid item xs={6} sm={4} key={item.key}>
                <div
                  style={{
                    background: item.bg,
                    borderRadius: "16px",
                    padding: "18px 16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    border: `1px solid ${item.color}22`,
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    cursor: "default",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow = `0 8px 20px ${item.color}22`;
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "none";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "12px",
                      background: item.color,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      boxShadow: `0 4px 12px ${item.color}44`,
                    }}
                  >
                    <Icon style={{ color: "#fff", fontSize: "1.4rem" }}>{item.icon}</Icon>
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "1.8rem",
                        fontWeight: 700,
                        color: item.color,
                        lineHeight: 1.1,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      {crmOverview[item.key] ?? "—"}
                    </div>
                    <div
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: 600,
                        color: "#607d8b",
                        marginTop: "4px",
                      }}
                    >
                      {item.label}
                    </div>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({ apolloClient: state.apolloClient });
const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(CrmOverview);
